// tslint:disable
export enum ClaimAdjudicationType {
    /**
     * @description Regular claim
     */
    Claim = 0,
    /**
     * @description Adjustment - change the amount paid to an existing approved claim
     */
    Adjustment = 1,
    /**
     * @description Reversal - undo an existing approved claim
     */
    Reversal = 2,
}
(ClaimAdjudicationType as any)['CLAIM'] = 0;
(ClaimAdjudicationType as any)['ADJUSTMENT'] = 1;
(ClaimAdjudicationType as any)['REVERSAL'] = 2;
